import React, { useState } from 'react';
import classNames from 'classnames';
import { CopyIcon } from '../../../design/assets/tone/copy.icon';
import styles from './copy-button.module.css';
import { useMediaQuery } from '../../../library';
export function CopyButton(_a) {
    var _b;
    var label = _a.label, value = _a.value;
    var _c = useState(false), copied = _c[0], setCopied = _c[1];
    var isMobile = useMediaQuery('screen and (max-width: 580px)');
    function onClickHandler() {
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(function () { return setCopied(false); }, 5000);
    }
    return (React.createElement("div", { className: styles.copyButtonContainer },
        React.createElement("button", { className: classNames(styles.copyButton, (_b = {}, _b[styles.copied] = copied, _b)), onClick: onClickHandler },
            React.createElement(CopyIcon, { tone: "text" }),
            !isMobile && (React.createElement("label", { className: styles.copyButtonLabel, htmlFor: label },
                React.createElement("div", { className: styles.copyButtonLabelActual }, label),
                React.createElement("div", { className: classNames(styles.copyButtonLabelActual, styles.copyButtonLabelCopied) }, "Copied")))),
        React.createElement("input", { className: styles.copyButtonInput, id: label, readOnly: true, value: value })));
}
export default CopyButton;
